import React, { useState, useContext } from 'react';
import { ConfigContext } from '../../Config/ConfigContext';
import FacebookOAuthProvider from '.';
import FacebookLogin from './FacebookLogin';

import AuthLoadingContainer from '../AuthLoadingContainer';
import {
    Box,
} from '@mui/material';
import { parseJwt } from '../../utils/jwt';
import http from '../../utils/http';
import auth from '../../utils/auth';

export default function FacebookOAuthChoice(props) {
    const [fbScriptLoaded, setFbScriptLoaded] = useState(false);
    const [authSucceeded, setAuthSucceeded] = useState(false);
    const { config } = useContext(ConfigContext);

    return (
        <FacebookOAuthProvider
            onScriptLoadSuccess={() => setFbScriptLoaded(true)}
            appId={config.facebookOAuth.appId}
        >
            {!fbScriptLoaded && <AuthLoadingContainer />}
            {!authSucceeded && fbScriptLoaded &&
                <Box sx={{
                }}>
                    <FacebookLogin
                        onSuccess={async ({ credentialResponse }) => {
                            const bearerTokenObject = parseJwt(auth.getBearerToken());
                            let tenantId = bearerTokenObject.tenantId;
                            let initURL = `${config.uri.base}/user/init`;
                            if (tenantId) initURL += `&tenantId=${tenantId}`;
                            const bearerToken = await http.get({
                                oauthResponse: JSON.stringify(credentialResponse),
                                signInPlatform: 'facebook',
                                signInToken: credentialResponse.authResponse.accessToken,
                            }, initURL, { withCredentials: true });
                            auth.setBearerToken(bearerToken);
                            setAuthSucceeded(true);
                            props.setAuthSuccess(true);
                        }}
                    />
                </Box>
            }
        </FacebookOAuthProvider>
    );
}
